import {futureDateValidator} from '@/common/validator/futureDateValidator';
import {Component} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {LoaderService} from '@services/loader.service';
import {MedicationService} from '@services/medication.service';
import {FarmService} from '@services/farm.service';
import {ToastrService} from 'ngx-toastr';
import {Observable} from 'rxjs';
import {MedicationUnitOptions} from '@/common/Enum/MedicationType.Enum';
@Component({
    selector: 'app-add-medication',
    templateUrl: './add-medication.component.html',
    styleUrl: './add-medication.component.scss'
})
export class AddMedicationComponent {
    public medicationForm: FormGroup;
    public currentDate: string;
    public farms: any[] = [];
    public classifications: any[] = [];
    public suppliers: any[] = [];
    public applications: any[] = [];
    public chickTypes: any[] = [];
    public isAuthLoading = false;
    public isLoading$: Observable<boolean>;
    public UserDetail: any;
    public userId: any;
    public medicationUnitOptions = MedicationUnitOptions;
    constructor(
        private fb: FormBuilder,
        private toastr: ToastrService,
        private loaderService: LoaderService,
        private medicationService: MedicationService,
        private farmService: FarmService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.UserDetail = JSON.parse(localStorage.getItem('UserDetail'));
        this.userId = this.UserDetail.id;
        const today = new Date();
        this.currentDate = today.toISOString().split('T')[0]; // Format as YYYY-MM-DD
        this.medicationForm = this.fb.group({
            farmId: ['', Validators.required],
            minimumStockAlert: ['', [Validators.required, Validators.min(0)]],
            medicationUnit: ['', Validators.required],
            name: ['', Validators.required],
            arabicBrandName: ['', Validators.pattern(/^[\u0600-\u06FF0-9-\s]+$/)],
            supplierId: ['', Validators.required],
            expiryDate: ['', [Validators.required, futureDateValidator()]],
            chickTypeId: ['', Validators.required],
            applicationId: ['', Validators.required],
            batchNumber: ['', Validators.required],
            qty: ['', [Validators.required, Validators.min(0)]],
            chickAgeFrom: ['', [Validators.required, Validators.min(0)]],
            chickAgeto: ['', [Validators.required, Validators.min(0)]],
            classificationId: ['', Validators.required],
            userId: this.userId,
            description: ['']
        });
        this.getFarmTypeList();
        this.getChicksTypeList();
        this.getApplicationTypeList();
        this.getClassificationTypeList();
        this.getSupplierTypeList();
    }
    // Direct focus to open the datepicker
    triggerDatePicker(event: any): void {
        // alert('v');
        const dateInput = event.target;
        dateInput.focus();
        dateInput.click(); // Ensure a click is triggered if focus alone doesn't work
    }
    getChicksTypeList() {
        this.medicationService.getChicksTypeList().subscribe((result) => {
            console.log(result);
            this.chickTypes = result;
        });
    }
    getApplicationTypeList() {
        this.medicationService.getApplicationTypeList().subscribe((result) => {
            console.log(result);
            this.applications = result;
        });
    }
    getClassificationTypeList() {
        this.medicationService.getClassificationList().subscribe((result) => {
            // console.log(result);
            this.classifications = result;
        });
    }
    getSupplierTypeList() {
        this.medicationService.getSuppierList().subscribe((result) => {
            // console.log(result);
            this.suppliers = result;
        });
    }

    getFarmTypeList() {
        this.farmService.getFarmList(this.userId).subscribe((result) => {
            this.farms = result;
        });
    }
    onSubmit(): void {
        this.loaderService.showLoader();
        this.isAuthLoading = true;
        if (this.medicationForm.valid) {
            const medicationData = this.medicationForm.value;
            console.log(medicationData);
            this.medicationService.addMedication(medicationData).subscribe({
                next: (response) => {
                    setTimeout(() => {
                        this.isAuthLoading = false;
                        this.loaderService.hideLoader();
                        this.toastr.success('Medication Added Successfully');
                    }, 2000);
                    this.router.navigate(['/medication-list']);
                },
                error: (error) => {
                    console.log(error);
                    setTimeout(() => {
                        this.isAuthLoading = false;
                        this.loaderService.hideLoader();
                        // Handle login error
                        this.toastr.error(error.error);
                    }, 2000);
                }
            });
        } else {
            this.loaderService.hideLoader();
            this.medicationForm.markAllAsTouched();
            this.isAuthLoading = false;
            this.toastr.error('Please fill the required fields');
        }

        // Handle the form submission to the backend here
    }

    onClose(): void {
        this.router.navigate(['/medication-list']);
    }
}
